class Auth {
    constructor() {
        this.authenticated = false
    }

    login(cd) {
        this.authenticated = true
        cd();
        window.location.reload();
    }

    logout(cd) {
        this.authenticated = false
        cd();
        window.location.reload();
    }

    isAuthenticated() {
        this.authenticated = (localStorage.getItem('token') != null);
        return this.authenticated;
    }
}
export default new Auth()


// WEBPACK FOOTER //
// ./src/auth.js